import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button", "progress", "progressBar", "status"];

  async uploadAll() {
    const pending = Array.from(
      document.querySelectorAll(
        "[data-controller~='map-queue-row'][data-map-queue-row-uploaded-value='false']",
      ),
    );

    if (pending.length === 0) {
      alert("No pending uploads on this page.");
      return;
    }

    if (
      !confirm(
        `Upload ${pending.length} file${pending.length === 1 ? "" : "s"}?`,
      )
    ) {
      return;
    }

    this.buttonTarget.disabled = true;
    this.progressTarget.classList.remove("d-none");

    let completed = 0;
    let failed = 0;
    const errors = [];

    for (const rowEl of pending) {
      const controller = this.application.getControllerForElementAndIdentifier(
        rowEl,
        "map-queue-row",
      );
      if (controller) {
        const result = await controller.performUpload();
        if (!result.ok) {
          failed++;
          errors.push(
            `${rowEl.dataset.mapQueueRowFilenameValue}: ${result.error}`,
          );
        }
      } else {
        failed++;
      }
      completed++;
      this.updateProgress(completed, pending.length, failed);
    }

    this.buttonTarget.disabled = false;
    this.buttonTarget.innerHTML = "Upload All Pending";

    if (errors.length > 0) {
      alert(
        `${errors.length} upload${errors.length === 1 ? "" : "s"} failed:\n\n` +
          errors.join("\n"),
      );
    }
  }

  updateProgress(current, total, failed) {
    const percent = Math.round((current / total) * 100);
    this.progressBarTarget.style.width = percent + "%";
    this.progressBarTarget.setAttribute("aria-valuenow", percent);
    const failedText = failed > 0 ? ` (${failed} failed)` : "";
    this.statusTarget.textContent = `${current} / ${total}${failedText}`;
  }
}
